// extracted by mini-css-extract-plugin
export default {"link":"NotFound_link__qdbND"};